import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Box, Popover, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { memo, useCallback, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import configs from '../../../../configs/config';
import { storeFiltersValue } from "../../../../redux/actions/TicketsManagement/GetTickets";
import { IState } from "../../../../redux/reducers/rootReducers";
import ConfirmationModel from "../../../common2/ConfirmationModel";
import AsyncFilterMenu from './AsyncFilterOption';
const orgEndpoint = `${configs.BASE_URL}/ContactOrganisation`;

const statusesToHideTemp = ["New", "NewtoMe", "Delete"];
export const FilterOptions = memo(({isSuperAdmin, TicketStatus, TicketTypes, Priorities,actionType="",selectorKey="filtersTicketManagementReducer"}:{actionType?:string,selectorKey?:string,isSuperAdmin:any, TicketStatus:any, TicketTypes:any, Priorities:any}) =>{
    const classes = filteruseStyles();
    const checkedTicketStatus = useSelector((state:any) => state?.[`${selectorKey}`]?.statuses);
    const checkedPriorities = useSelector((state:any) => state?.[`${selectorKey}`]?.priorities);
    const checkedTicketTypes = useSelector((state:any) => state?.[`${selectorKey}`]?.ticketTypes);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [statusesToHide] = useState<string[]>(isSuperAdmin ?  ["New", "NewtoMe"] : statusesToHideTemp);
    const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    },[]);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleClose = () => {
        setAnchorEl(null);
    };
    // useEffect(()=>{
    //     console.log('ticketFilterValues',ticketFilterValues,TicketStatus,TicketTypes,Priorities)
    // },[ticketFilterValues,TicketStatus,TicketTypes,Priorities,OrgList])
    const addBtn = useMemo(() => <>
        <Typography aria-describedby={id} onClick={handleClick} className={`${classes.filterItem} ${checkedTicketStatus.length + checkedTicketTypes.length + checkedPriorities.length > 0 ? "active" : ""}`}>
            <FilterAltOutlinedIcon />
            Filter {checkedTicketStatus.length + checkedTicketTypes.length + checkedPriorities.length > 0 && <>
                ({checkedTicketStatus.length + checkedTicketTypes.length + checkedPriorities.length })
            </>}
            <ArrowDropDownIcon />
        </Typography>
    </>, [checkedTicketStatus?.length,checkedTicketTypes?.length,checkedPriorities?.length,classes]);

    const statusList = useMemo(() => <>
    {TicketStatus && TicketStatus.length&&<Box>
        <Typography className={classes.filterTitle} sx={{ p: 1 }}>Choose Ticket Status</Typography>
        <Box sx={{ p: 1 }}>
            <CheckboxList options={TicketStatus.filter((i: any) => !statusesToHide.includes(i.name))} values={checkedTicketStatus} keyVal={`TCKT_STATUS_VALUE${actionType}`} />
        </Box>
    </Box>}</>, [checkedTicketStatus,classes])

    const TicketTypesList = useMemo(() => <>
        {TicketTypes && TicketTypes.length && <Box>
            <Typography className={classes.filterTitle} sx={{ p: 1 }}>Choose Ticket Types</Typography>
            <Box sx={{ p: 1 }}>
                <CheckboxList options={TicketTypes} values={checkedTicketTypes} keyVal={`TCKT_TICKET_TYPE_VALUE${actionType}`} />
            </Box>
        </Box>}</>, [checkedTicketTypes,classes])
    
    
    const PrioritiesList = useMemo(() => <>
        {Priorities && Priorities.length && <Box>
            <Typography className={classes.filterTitle} sx={{ p: 1 }}>Choose Priorities</Typography>
            <Box sx={{ p: 1 }}>
                <CheckboxList options={Priorities} values={checkedPriorities} keyVal={`TCKT_PRIORITIES_VALUE${actionType}`} />
            </Box>
        </Box>}</>, [checkedPriorities])
    return (
        <>
             {addBtn} 
            <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                <Box className={`${classes.row}`}>
                    {statusList}

                    {TicketTypesList}
                    
                    {PrioritiesList}
                    
                    
            <AsyncFilterMenu selectorKey={selectorKey}  label='Organisations' endpoint={`${orgEndpoint}?page=1&count=15&isActive=true&`} />

                </Box>
            </Popover>
        </>
    )
})
const CheckboxList = memo((props:any) =>{
    const classes = filteruseStyles();
    const dispatch = useDispatch();
    const {options,values,keyVal} = props;
    //Fetch current layout is chosen.
    const layoutType = useSelector(
        (state:any)=> state?.LayoutTicketManagementReducer?.layout
    );
    //The Below code is to handle the scenario when user selects closed status in status layout, we want to show a confirmation pop-up to switch to list layout as closed status has more brief overview which can be viewed in list / priority layout only.
    const [pendingFilter, setPendingFilter] = useState<any>(null);
    const closedOption = options.find((o:any)=>o?.name?.toLowerCase() === "closed");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleDeleteConfirm = () => {
        if (pendingFilter) {
            dispatch(storeFiltersValue(pendingFilter, keyVal));
            dispatch(storeFiltersValue("List", 'TCKT_LAYOUT_VALUE'));
        }
        setPendingFilter(null);
        setIsModalOpen(false);
    };
    const handleModalClose = () => {
        if(pendingFilter){
            const updatedStatuses = pendingFilter.filter(
                (id:any)=> id !== closedOption?.id
            );
            dispatch(storeFiltersValue(updatedStatuses, keyVal));
        }
        setPendingFilter(null);
        setIsModalOpen(false);
    };

    const clickHandler = (val: any, action: string, name: string) => {
        let tempArr: any = [...values];
        if (action === "add") {
            tempArr.push(val);
        } else {
            tempArr = tempArr.filter((i: any) => i !== val);
        }
        const isStatusLayout = layoutType?.toLowerCase() === "status";
        // If Layout is Status View and Ticket Status Filter is Closed -> ask confirmation Yes -> Switch to List View and apply filter, No -> Don't apply Closed filter and remain in Status View.
        if (name.toLowerCase() === "closed" && action === "add") {
            if(isStatusLayout){
            setPendingFilter(tempArr);
            setIsModalOpen(true);
            return;
            }
            dispatch(storeFiltersValue(tempArr, keyVal));
            return;
        }
        dispatch(storeFiltersValue(tempArr, keyVal));
        if(closedOption){
            if(tempArr.includes(closedOption.id)){
                dispatch(storeFiltersValue("List",'TCKT_LAYOUT_VALUE'));
            }
        }
    }
    return(
        <>
            {options?.map && options.map((i: any, index: number) => {
                const checked = values?.includes(i.id);
                return (
                    <>
                        <Typography key={index} onClick={() => { clickHandler(i.id, checked ? "remove" : "add", i.name) }} className={classes.filterItem}>
                            {checked ? <CheckBoxIcon className={`${classes.checkedIcon} checkbox-icon`}/> : <CheckBoxOutlineBlankIcon />} 
                            <span>{i?.displayName ? i?.displayName : i?.name}</span>
                        </Typography>
                    </>
                )
            })}
            {closedOption &&  
                <ConfirmationModel
                    open={isModalOpen}
                    labelTop="Switch to List View?"
                    labelBottom="Closed tickets can be viewed."
                    onSubmitHandler={handleDeleteConfirm}
                    handleClose={handleModalClose}
                    btn="Yes" />
            }
        </>
    )
});
export const filteruseStyles = makeStyles(() => ({
    row:{
        display:"flex"
    },
    filterItem:{
        fontSize:"11px",
        cursor:"pointer",
        padding: "2px 5px",
        display: "flex",
        alignItems: "center",
        gap: "2px",
        "& svg":{
            width: "18px",
            height: "18px",
            color: "#777",
        }
    },
    filterTitle:{
        fontSize:"13px",
        borderBottom:"1px solid #ddd"
    },
    checkedIcon:{
        color:"#007bff !important"
    }
}));


const mapStateToProps = (state:IState) => {
  return ({
    isSuperAdmin : state?.agentReducer?.loggedInAgent?.roles.isSuperAdmin,
    TicketStatus : state?.TicketsReducer?.allResponses?.ticketStatus,
    TicketTypes : state?.TicketsReducer?.allResponses?.TicketTypes,
    Priorities : state?.TicketsReducer?.allResponses?.priorities
  })
};

export default connect(mapStateToProps)(FilterOptions);